import * as Yup from 'yup'

import { EMPTY_OBJECT } from '../../../constants/common'
import {
  FORM_ERROR_NAME_RESPONSIBLE_MANAGERS_LIMIT_EXCEEDED,
  RESPONSIBLE_MANAGERS_LIMIT,
} from '../../Form'
import {
  getRequestEditUserModalInitialValue,
  getRequestEditUserModalPayload,
  getRequestEditUserModalValidationSchema,
} from '../RequestEditUserModal'

import { REQUEST_EDIT_MANAGER_FIELD_NAME_ASSIGNEES } from './RequestEditManagerModal.constants'

export function getRequestEditManagerModalInitialValues({
  itemAction,
  users,
} = EMPTY_OBJECT) {
  return getRequestEditUserModalInitialValue({
    itemAction,
    userFieldName: REQUEST_EDIT_MANAGER_FIELD_NAME_ASSIGNEES,
    users,
  })
}

export function getRequestEditManagerModalPayload(values) {
  return getRequestEditUserModalPayload({
    userFieldName: REQUEST_EDIT_MANAGER_FIELD_NAME_ASSIGNEES,
    values,
  })
}

export function getRequestEditManagerModalValidationSchema(params) {
  return getRequestEditUserModalValidationSchema(params).concat(
    Yup.object({
      [REQUEST_EDIT_MANAGER_FIELD_NAME_ASSIGNEES]: Yup.array().max(
        RESPONSIBLE_MANAGERS_LIMIT,
        FORM_ERROR_NAME_RESPONSIBLE_MANAGERS_LIMIT_EXCEEDED
      ),
    })
  )
}
